import React, { memo } from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { X } from 'lucide-react';
export function WhyDidntWork() {
  const reasons = [{
    title: 'Recetarios de internet',
    desc: 'Los recetarios comunes de internet no tienen el alma de tu hogar ni tus trucos específicos.'
  }, {
    title: 'Aplicaciones frías',
    desc: 'Las aplicaciones de cocina son complicadas y no capturan la anécdota detrás del plato.'
  }, {
    title: 'Confiar en la memoria',
    desc: 'Es peligroso; los detalles más importantes son los primeros que el tiempo borra.'
  }];
  return <section className="py-20 bg-heritage-coffee text-heritage-cream" data-id="element-197">
      <div className="max-w-5xl mx-auto px-6" data-id="element-198">
        <FadeIn data-id="element-199">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-heritage-cream" data-id="element-200">
            Por qué lo que has intentado{' '}
            <span className="text-heritage-gold italic" data-id="element-201">no ha funcionado</span>
          </h2>
        </FadeIn>

        <StaggerContainer className="grid md:grid-cols-3 gap-8" data-id="element-202">
          {reasons.map((reason, idx) => <StaggerItem key={idx} className="bg-white/5 p-8 rounded-xl border border-white/10" data-id="element-203">
              <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center mb-6" data-id="element-204">
                <X className="w-5 h-5 text-red-300" data-id="element-205" />
              </div>
              <h3 className="font-serif text-xl font-semibold mb-3 text-heritage-gold" data-id="element-206">
                {reason.title}
              </h3>
              <p className="text-heritage-cream/80 leading-relaxed" data-id="element-207">
                {reason.desc}
              </p>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}